import {
	GET_DASHBOARD,
	GET_DASHBOARD_SYSTEM_OVERVIEW,
	GET_DASHBOARD_ORGANIZATION_USAGE,
	GET_DASHBOARD_PERFORMANCE_METRICS,
} from "constants/actions";

const initialState = {
	dashboard: {},
	system_overview: {},
	organization_usage: {},
	performance_metrics: {},
	pending: false,
};

export default function ActionDashboard(state = initialState, action) {
	switch (action.type) {
		case GET_DASHBOARD:
			return {
				...state,
				dashboard: action.payload,
				pending: false,
			};

		case GET_DASHBOARD_SYSTEM_OVERVIEW:
			return {
				...state,
				system_overview: action.payload,
				pending: false,
			};

		case GET_DASHBOARD_ORGANIZATION_USAGE:
			return {
				...state,
				organization_usage: action.payload,
				pending: false,
			};

		case GET_DASHBOARD_PERFORMANCE_METRICS:
			return {
				...state,
				performance_metrics: action.payload,
				pending: false,
			};

		default:
			return state;
	}
}

